// src/services/api.js

export async function fetchSettingsData() {
    try {
      const raw = "";
      const response = await fetch("https://admin.astrogurujii.com/user_api/setting", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },body: raw
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      return data.results; // only return "results" object
    } catch (error) {
      console.error("API Fetch Error:", error);
      throw error;
    }
  }
  